export const API_TOKEN = process.env.REACT_APP_API_TOKEN ?? "";
export const PAYMENT_PHONE = process.env.REACT_APP_PAYMENT_PHONE;
